import { UiWrapper } from '@coinscrap/webapp-core';

export const LoadingData = () => {
  const { useLoading } = UiWrapper.use();
  useLoading(true);
  return null;
};
